import { useContext } from 'react'

import { GlobalConfigContext } from 'main/context/global-config-provider'

export const useGlobalConfig = () => {
  return useContext(GlobalConfigContext)
}
